<svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_13092_194536)">
<path d="M1.73393 8.64639L11.604 0.100116C11.9362 -0.187517 12.42 0.198474 12.2134 0.58627L8.99138 6.63339H14.5924C14.9606 6.63339 15.1299 7.0916 14.8502 7.33105L4.83779 15.9017C4.50623 16.1855 4.02638 15.8035 4.22865 15.4168L7.40552 9.34258H1.99345C1.62635 9.34258 1.45641 8.88669 1.73393 8.64639Z"/>
</g>
<defs>
<clipPath id="clip0_13092_194536">
<rect width="16" height="16" fill="white" transform="translate(0.596191 0.00012207)"/>
</clipPath>
</defs>
</svg>
